import {
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';

import { Spread } from '../interfaces/spread';

@Component({
  selector: 'previews',
  styleUrls: ['./previews.component.scss'],
  templateUrl: './previews.component.html',
})
export class PreviewsComponent implements OnChanges {
  @Input() currentSpread: number;
  @Input() spreads: Spread[];
  @Output() onChangeSpread = new EventEmitter();

  constructor(private previewsContainer: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if ('currentSpread' in changes) {
      this.scrollPreviewContainer(changes['currentSpread'].currentValue);
    }
  }

  private setScrollForPreviewContainer(scrollLeft, smooth = false) {
    const pc = this.previewsContainer.nativeElement;
    const maxScrollLeft = pc.scrollWidth - pc.offsetWidth;

    if (scrollLeft < 0) {
      pc.scrollTo({ left: 0, behavior: smooth ? 'smooth' : undefined });
    } else if (scrollLeft > maxScrollLeft) {
      pc.scrollTo({
        left: maxScrollLeft,
        behavior: smooth ? 'smooth' : undefined,
      });
    } else {
      pc.scrollTo({
        left: scrollLeft,
        behavior: smooth ? 'smooth' : undefined,
      });
    }
  }

  private scrollPreviewContainer(pictureIndex) {
    const pictureElement = document.getElementById(`picture-${pictureIndex}`);
    if (!this.previewsContainer || !pictureElement) {
      return;
    }

    const pc = this.previewsContainer.nativeElement;

    const offsetLeft =
      pictureElement.offsetLeft -
      this.previewsContainer.nativeElement.offsetLeft -
      pc.offsetWidth / 2 +
      pictureElement.offsetWidth / 2;
    this.setScrollForPreviewContainer(offsetLeft, true);
  }
}
